module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new/_next/static/images/marquee_desktop2-35a7f805a1331d552f30ef38b0a2190e.jpg";